import { currentLanguage } from "../../algorithms/storage";
import axios from "../axiosConfig";
export const userLogin = (data) => {
  return axios.post("Identity/Login", data);
};

export const userApplicant = (data) => {
  return axios.post("Applicant/RegisterApplicant", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const refreshToken = (token) => {
  return axios.post(`Identity/Refresh?Token=${token}`);
};

export const userDataFromToken = (userId, token) => {
  return axios.get(`Identity/GetUser?UserId=${userId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const userLogout = () => {
  return axios.post(`Identity/Logout`);
};

export const userForgetPassword = (email) => {
  return axios.post(`Identity/ForgetPassword?Email=${email}`);
};

export const userResetPassword = (email, password, token) => {
  return axios.post(
    `Identity/ResetPassword?Email=${email}&Password=${password}&Code=${token}`
  );
};

export const userDetails = (userId, token) => {
  return axios.get(`Identity/GetUserProfileDetails?UserId=${userId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUserCounts = (userId, token) => {
  return axios.get(`Profile/GetMemberDataCount/${userId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getMemberLists = (userId, componentId, token) => {
  if (componentId == "A1")
    return axios.get(`Profile/GetMemberCommunity/${userId}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (componentId == "A2")
    return axios.get(`Profile/GetMemberProject/${userId}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (componentId == "A3")
    return axios.get(`Profile/GetMemberTask/${userId}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (componentId == "A4")
    return axios.get(`Profile/GetMemberForum/${userId}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (componentId == "A6")
    return axios.get(`Message/GetMessages/${userId}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
};

export const delPost = (postId, token) => {
  return axios.delete(`Message/DeleteMessage/${postId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

// messenger

export const addRoom = (data, token) => {
  return axios.post("Inbox/AddRoom", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const isRoom = (senderId, recieverId, token) => {
  return axios.get(`Inbox/IsRoom/${senderId}/${recieverId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getRooms = (token) => {
  return axios.get("Inbox/GetRooms", {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getRoom = (roomId, token) => {
  return axios.get(`Inbox/GetRoom/${roomId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addMessageData = (data, token) => {
  return axios.post("Inbox/AddMessagetoRoom", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addProfilePostData = (body, token) => {
  return axios.post(`Message/AddMessage`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditPostData = (postId, token) => {
  return axios.get(`Message/EditMessage/${postId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editPost = (data = {}, token) => {
  return axios.put(`Message/EditMessage`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCommentData = (body, token) => {
  return axios.post(`Message/AddMessageReply`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getPostData = (id, token) => {
  return axios.get(`Message/GetMessage/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
